module.exports = __webpack_public_path__ + "img/video.5b8df3fe.jpg";